import styled from "styled-components";
import { device } from "../../utils/Environment";

export const Heading = styled.h2`
  padding: 0 10%;
  margin-bottom: 20px;
  font-size: 1.2rem;
  overflow-wrap: break-word;

  @media ${device.tablet} {
    font-size: 2rem;
  }
`;

export const Text = styled.p`
  margin-bottom: 20px;
  font-size: 1rem;
  padding: 0 10%;

  @media ${device.tablet} {
    font-size: 1.3rem;
  }
`;

export const List = styled.ol`
  margin-bottom: 20px;
  font-size: 1rem;
  padding: 0 15%;

  @media ${device.tablet} {
    font-size: 1.3rem;
  }
`;

export const ListItem = styled.li``;

export const Link = styled.a``;

export const BulletList = styled.ul``;
